import { isFetchBaseQueryError } from "./isFetchBaseQueryError";

export const isNoAccessStatus = (status: unknown): boolean => status === 401 || status === 403 || status === 404;

// The BFF's not-found body is plain text, which RTK Query reports as PARSING_ERROR with the HTTP status in originalStatus.
export const isNoAccessError = (error: unknown): boolean =>
  isFetchBaseQueryError(error) &&
  (isNoAccessStatus(error.status) || (error.status === "PARSING_ERROR" && isNoAccessStatus(error.originalStatus)));

export const isSignedOutError = (error: unknown): boolean =>
  isFetchBaseQueryError(error) &&
  (error.status === 401 || (error.status === "PARSING_ERROR" && error.originalStatus === 401));

export const isForbiddenError = (error: unknown): boolean =>
  isFetchBaseQueryError(error) &&
  (error.status === 403 || (error.status === "PARSING_ERROR" && error.originalStatus === 403));
